import { useMemo, useState } from "react";

import { useTaskContext, useWebViewerContext } from "../../../providers";

import { Mask } from "../../../types/masks";

import EmptyMasks from "../../../components/Empty/EmptyMasks";
import EmptyMasksFiltered from "../../../components/Empty/EmptyMasksFiltered";
import FeedbackCard from "../../../components/FeedbackCard/FeedbackCard";

import styles from "./RightAside.module.css";
import { CriteriaOption } from "../../../types/task";
import CriteriaTag from "../../../components/Tag/CriteriaTag";

const MasksList = ({
  masksList,
  hasFiltersApplied,
}: {
  masksList: Mask[];
  hasFiltersApplied: boolean;
}) => {
  const [feedbackSelected, setFeedbackSelected] = useState<Mask | null>(null);
  const [selectedCriterion, setSelectedCriterion] = useState<CriteriaOption | null>(null);

  const { goToAnnotation } = useWebViewerContext();
  const { task } = useTaskContext();

  const filteredByCriterion = useMemo(() => {
    if (!selectedCriterion) return masksList;
    return masksList.filter((m) => (m.criteria || "").toUpperCase() === selectedCriterion);
  }, [masksList, selectedCriterion]);

  const hasAnyFilterApplied = hasFiltersApplied || Boolean(selectedCriterion);
  const documentHasNoMasks = !hasAnyFilterApplied && masksList.length === 0;
  const filtersAppliedHasNoResults = hasAnyFilterApplied && filteredByCriterion.length === 0;

  const clearSelectedCriterion = () => setSelectedCriterion(null);

  return (
    <>
      {task && <div className={styles.masksListHeader}>
        {selectedCriterion && (
          <button className={styles.clearCriterionButton} onClick={clearSelectedCriterion}>Borrar filtre</button>
        )}
        {task.criteria.map((criterion: CriteriaOption) => (
          <CriteriaTag
            key={criterion}
            criteria={criterion}
            selected={selectedCriterion === criterion}
            onClick={() => setSelectedCriterion((prev) => prev === criterion ? null : criterion)}
          />
        ))}
      </div>}
      {documentHasNoMasks && <EmptyMasks />}
      {filtersAppliedHasNoResults && <EmptyMasksFiltered />}
      <ul className={styles.masksList}>
        {filteredByCriterion.map((maskInfo) => (
          <FeedbackCard
            goToAnnotation={goToAnnotation}
            selected={maskInfo.id === feedbackSelected?.id}
            key={maskInfo.id}
            maskInfo={maskInfo}
            onSelect={() => {setFeedbackSelected(maskInfo);}}
          />
        ))}
      </ul>
    </>
  );
};
export default MasksList;
